<div class="row align-items-center">
  @if (iconType == iconTypes.Info) {
    <i
      id="{{tooltipIconId}}"
      class="ri-icon rif-icon_information info-icon"
      (mouseenter)="onIconMouseEnter()"
      (mouseleave)="onIconMouseLeave()">
    </i>
  }
  @if (iconType == iconTypes.Warning) {
    <div
      class="alert-container"
      id="{{tooltipIconId}}"
      (mouseenter)="onIconMouseEnter()"
      (mouseleave)="onIconMouseLeave()"
      (click)="onIconClick()"
      >
      <img
        src="../../../../assets/icons/alert.svg"
        width="34"
        height="34"
        />
      </div>
    }
    <dx-tooltip
      [wrapperAttr]="{ class: 'icon-tootip-wrapper' }"
      target="{{targetId}}"
      [(visible)]="isVisible"
      [hideOnOutsideClick]="true"
      (onHiding)="onHidingTooltip()"
      >
      <div *dxTemplate="let data of 'content'">
        <ng-content></ng-content>
      </div>
    </dx-tooltip>
  </div>
